angular.module('clients')
    .component('clientCategoryPicker', {
        require: {
            ngModelCtrl: 'ngModel'
        },
        bindings: {
            required: "<?",
            filterField: "<?",
            onChange: "&"
        },
        templateUrl: "app/clients/client-category-picker/picker.html",
        controller: function(Client) {
            const ctrl = this;

            ctrl.$onInit = () => {
                ctrl.required = ctrl.required || false;
                ctrl.filterField = ctrl.filterField || false;

                ctrl.loadItems()

                ctrl.ngModelCtrl.$render = () => ctrl.selected = ctrl.ngModelCtrl.$viewValue;
                ctrl.ngModelCtrl.$formatters.push(modelValue => modelValue);
                ctrl.ngModelCtrl.$parsers.push(viewValue => viewValue);
            };

            ctrl.onSelectionChanged = ($item, $model) => {
                ctrl.ngModelCtrl.$setViewValue($item);
                ctrl.ngModelCtrl.$validate();
                ctrl.ngModelCtrl.$render();
                if (angular.isFunction(ctrl.onChange())) {
                    ctrl.onChange()($item);
                }
            };
            ctrl.loadItems = () => Client.categories().$promise.then(items => ctrl.items = items)
        }
    })
